import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td {
        margin: 0;
        padding: 0;
    }

    body {
        -webkit-font-smoothing: antialiased;
        min-height: 100%;
        width: 100%;
        font-family: "Open Sans",Tahoma,Geneva,sans-serif;
    }

    html {
        overflow: auto !important;
    }

    a {
        text-decoration: none;
    }

    fieldset, img {
        border: 0;
    }

    img {
        vertical-align: middle;
        max-width: 100%;
    }

    strong {
        font-style: normal;
        font-weight: bold;
    }

    address, caption, cite, code, dfn, em, th, var {
        font-style: normal;
        font-weight: normal;
    }

    ol, ul {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    q:before, q:after {
        content: '';
    }

    abbr, acronym {
        border: 0;
        font-variant: normal;
    }

    sup {
        vertical-align: text-top;
    }

    sub {
        vertical-align: text-bottom;
    }

    input, textarea, select {
        font-family: inherit;
        font-size: 100%;
        font-weight: inherit;
    }

    *, *:before, *:after {
        box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    input[type="text"], textarea {
        appearance: none;
    }

    button {
        margin: 0px;
        border: none;
    }
`;
